import { useState } from 'react';

import { Notification } from '@/component';
import MyProfile from '@/component/User/MyProfile';
import { LANG } from '@/constant/appConstant';
import { VDrawer, VFlex, VLanguageSwitcher, useUnleash } from '@/package';
import { useMainLayout } from '@/provider/layout';
import { useLangStore } from '@/store';

import UserPopover from './UserPopover';

const MainLayoutHeader = () => {
  const { language, changeLanguage } = useLangStore();
  const { isEnabled } = useUnleash();
  const { title } = useMainLayout();
  const [isMyAccountVisible, setIsMyAccountVIsible] = useState(false);
  const langItemList = (Object.keys(LANG) as (keyof typeof LANG)[])
    .filter(key => {
      if (key === 'JP' && !isEnabled('vuex.sapporo.jpEnabled')) return false;

      return true;
    })
    .map(key => ({
      label: (() => {
        if (key === 'KO') return '한국어 - KO';
        if (key === 'EN') return 'English - EN';
        // if (key === 'CN') return '中文 - CN';
        if (key === 'JP') return '日本語 - JP';

        return '한국어 - KO';
      })(),
      value: LANG[key],
    }));

  return (
    <>
      <VFlex
        className="relative h-14 w-full px-8 py-[5px] shadow-sm"
        items="center"
        justify="between"
      >
        {typeof title === 'function' ? (
          title()
        ) : (
          <div className="text-headline-sm font-semibold">{title}</div>
        )}

        <VFlex gap={0.25} items="center">
          <Notification />
          <UserPopover setIsMyAccountVIsible={setIsMyAccountVIsible} />
          <VLanguageSwitcher
            languageList={langItemList}
            selectedLanguage={language}
            onItemClick={lang => changeLanguage(lang.value)}
            placement="bottom-right"
          />
        </VFlex>
      </VFlex>
      <VDrawer
        dialogMainClass="bg-white"
        position="right"
        size="xs"
        visible={isMyAccountVisible}
        onUpdateVisible={setIsMyAccountVIsible}
      >
        <MyProfile setVisible={setIsMyAccountVIsible} />
      </VDrawer>
    </>
  );
};

export default MainLayoutHeader;
